import request from 'superagent';

export default async function getMapAddress({ data, saveFn }) {
  const proxy = await request.post('/portal-srp/api/v1/smartsuggest/getaddress')
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .withCredentials()
    .send({ coords: data.coords });

  if (proxy && proxy.status === 200) {
    const { body } = proxy;
    if (body && body.streetName && body.city) {
      saveFn({
        data,
        streetName: body.streetName,
        city: body.city,
      });
    }
  }
}
